import Player from '@vimeo/player';

export default {

	init() {
		const video = Array.from(document.querySelectorAll('[data-video-id]'));
		video.forEach((elm) => {
			elm.addEventListener('click', (event) => {
				event.preventDefault();
				const target = event.currentTarget;
				const wrapper = target.closest('.video');
				const playerWrapper = wrapper.querySelector('.video__player');
				playerWrapper.classList.remove('hidden');
				const player = new Player(playerWrapper, {
					id: target.dataset.videoId,
					autoplay: true,
					responsive: true,
				});
				player.on('ended', () => {
					playerWrapper.classList.add('hidden');
				});
			});
		});
	},

};
